import Spinner from '@/components/Spinner'
import { addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostMutation } from '@/generated/@tanstack/react-query.gen'
import { useUser } from '@/pages/enterprise/user-provider'
import { useMutation } from '@tanstack/react-query'
import { useEffect } from 'react'
import { PlaidLinkOptions, usePlaidLink } from 'react-plaid-link'
import { toast as customToast } from '@/components/custom-toast'
import { create } from 'zustand'
import PaymentMethodStripeWrapper from './payment-method-stripe-warpper'
import { useStripe } from '@stripe/react-stripe-js'
import { get } from 'lodash'

interface PlaidLinkState {
  linkToken: string | undefined
  setLinkToken: (token: string | undefined) => void
  resetStore: () => void
}

export const usePlaidLinkStore = create<PlaidLinkState>((set) => ({
  linkToken: undefined,
  setLinkToken: (token) => set({ linkToken: token }),
  resetStore: () => set({ linkToken: undefined }),
}))

export const PaymentMethodPlaidLinkComponent = () => {
  const { linkToken } = usePlaidLinkStore()

  if (linkToken) {
    return (
      <PaymentMethodStripeWrapper>
        <PaymentMethodPlaidLink linkToken={linkToken} />
      </PaymentMethodStripeWrapper>
    )
  }
  return <></>
}

export const PaymentMethodPlaidLink = ({
  linkToken,
}: {
  linkToken: string
}) => {
  const { organizationId } = useUser()
  const { onUpdateSeats } = useUser()
  const stripe = useStripe()
  const { resetStore } = usePlaidLinkStore()

  const config: PlaidLinkOptions = {
    onSuccess: (public_token, metadata) => {
      mutate({
        path: {
          organization_id: organizationId,
        },
        body: {
          public_token,
          account_id: metadata.accounts[0].id,
        },
      })
    },
    token: linkToken ?? null,
  }

  const { mutate, isPending: isPendingAddACH } = useMutation({
    ...addPaymentMethodAchOrganizationOrganizationIdAddPaymentMethodAchPostMutation(
      {}
    ),
    onSuccess: (data) => {
      if (get(data, 'status') === 'success') {
        return onAddACHSuccess()
      }

      const clientSecret = get(data, 'clientSecret', '')
      const payment_method_id = get(data, 'payment_method_id', '')
      mutateConfirmCard({
        clientSecret,
        payment_method_id,
      })
    },
    onError: (error) => {
      return customToast.error({
        message: error.toString(),
      })
    },
  })

  const { mutate: mutateConfirmCard, isPending: isPendingConfirmCard } =
    useMutation({
      mutationFn: async ({
        clientSecret,
        payment_method_id,
      }: {
        clientSecret: string
        payment_method_id: string
      }) => {
        const result = await stripe!.confirmUsBankAccountPayment(clientSecret, {
          payment_method: payment_method_id,
        })
        if (result.error) {
          throw new Error('Failed to confirm ach payment. Please try again.')
        }
        return result.paymentIntent
      },
      onSuccess: () => onAddACHSuccess(),
      onError: () => {
        customToast.error({
          message: 'Failed to confirm ach payment. Please try again.',
        })
      },
    })

  const onAddACHSuccess = () => {
    onUpdateSeats()
    customToast.success({
      message: 'Payment method added successfully.',
    })
    resetStore()
  }
  const { open, ready } = usePlaidLink(config)

  const isPending = isPendingConfirmCard || isPendingAddACH

  useEffect(() => {
    if (ready) {
      open()
    }
  }, [ready])

  if (isPending || !ready) {
    return <Spinner />
  }

  return <></>
}
